module.exports = __webpack_public_path__ + "assets/webgl/section_1.fa2f583e.glb";